import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "middle-pane-content" }
const _hoisted_2 = {
  id: "vehicle-registration-pane",
  style: {"display":"none"}
}
const _hoisted_3 = {
  id: "insurance-pane",
  style: {"display":"none"}
}

import {
  PanesDirective as EPanes,
  PaneDirective as EPane,
  SplitterComponent
} from "@syncfusion/ej2-vue-layouts";
import {computed, ref, watch} from "vue";
import {useNavigationStore} from "@/modules/Navigation/store";
import {storeToRefs} from "pinia";
import InsuranceSideComponent from "@/modules/Insurance/components/InsuranceSideComponent.vue";
import SideHeaderComponent from "@/app/components/SideHeaderComponent.vue";
import ApiStatusBannerComponent from "@/app/components/ApiStatusBannerComponent.vue";
import VehicleRegistrationSideComponent
  from "@/modules/VehicleRegistration/components/VehicleRegistrationSideComponent.vue";
import {useDisplay} from 'vuetify'
import {useAccountStore} from "@/stores/accountStore";

interface Props {
  id?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'MainComponent',
  props: {
    id: { default: undefined }
  },
  setup(__props: any) {



const props = __props

const _splitter = ref<InstanceType<typeof SplitterComponent> | null>(null)

const _insuranceCreated = ref(false)
const _vehicleRegistrationCreated = ref(false)
const _navigationStore = useNavigationStore();
const _accountStore = useAccountStore()

const {currentInsuranceId, currentVehicleRegistrationId} = storeToRefs(_navigationStore)
const {mobile: _isMobile} = useDisplay()

const {isRoot} = storeToRefs(_accountStore)


const _vehicleRegistrationIndex = computed(() => {
  return _insuranceCreated.value ? 1 : 0;
})

function onClose(index: number) {
  _splitter.value.collapse(index)
}

watch(_isMobile, (value, oldValue) => {
  if (!oldValue && value) {
    if (_insuranceCreated.value) {
      _splitter.value.collapse(0)
    }
    if (_vehicleRegistrationCreated.value) {
      _splitter.value.collapse(_vehicleRegistrationIndex.value)
    }
  }
})

watch(currentInsuranceId, () => {
    if (_isMobile.value) {
      return;
    }
    if (!_splitter.value) {
      return
    }
    if (_insuranceCreated.value) {
      _splitter.value.expand(0)
    } else {
      _splitter.value.addPane({content: "#insurance-pane", size: '320px', min: "320px"}, 0)
      _insuranceCreated.value = true;
    }
  }
)

watch(currentVehicleRegistrationId, () => {
    if (_isMobile.value || !isRoot.value) {
      return;
    }
    if (!_splitter.value) {
      return
    }
    if (_vehicleRegistrationCreated.value) {
      _splitter.value.expand(_vehicleRegistrationIndex.value)
    } else {
      _splitter.value.addPane({
        content: "#vehicle-registration-pane",
        size: '400px',
        min: "350px"
      }, _vehicleRegistrationIndex.value)
      _vehicleRegistrationCreated.value = true;
    }
  }
)


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(SplitterComponent), {
      id: "default-splitter",
      ref_key: "_splitter",
      ref: _splitter
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(EPanes), null, {
          default: _withCtx(() => [
            _createVNode(_unref(EPane), { content: "#middle-pane-content" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ApiStatusBannerComponent),
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SideHeaderComponent, {
        onClose: _cache[0] || (_cache[0] = ($event: any) => (onClose(_vehicleRegistrationIndex.value)))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Kfz-Zulassung ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(VehicleRegistrationSideComponent)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SideHeaderComponent, {
        onClose: _cache[1] || (_cache[1] = ($event: any) => (onClose(0)))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Versicherungskarte ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(InsuranceSideComponent)
    ])
  ]))
}
}

})